import styled from 'styled-components';
import BottomModal from '../../../components/modal/BottomModal';
import {
  ModalCloseButton,
  ModalHeader,
  ModalTitle,
} from '../../../components/modal/Modal.style';

interface Props {
  onClose: () => void;
}

function CostIncludeModal({ onClose }: Props) {
  return (
    <BottomModal onClose={onClose}>
      <ModalHeader>
        <ModalTitle>부대비용</ModalTitle>
        <ModalCloseButton
          onClick={onClose}
          src="/assets/images/close/close-dark-gray.svg"
          alt="close"
        />
      </ModalHeader>
      <Content>
        부대비용에는 부동산 유형별로 취등록세, 법무사비, 명도비, 인테리어비 등이
        포함됩니다.
      </Content>
      <Footer>
        <Button onClick={onClose}>확인</Button>
      </Footer>
    </BottomModal>
  );
}

export default CostIncludeModal;

const Content = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  color: #616161;
  font-size: 13px;
  font-weight: 500;
  line-height: 150%;
  letter-spacing: -0.26px;
`;

const Footer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`;

const Button = styled.button`
  border: none;
  outline: none;
  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  flex: 1 0 0;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;
`;
